import { useNavigate } from 'react-router-dom';

import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import Dialog from 'components/dialog';

type NPIDuplicateDialogProps = {
  open: boolean;
  onClose: () => void;
  physicianName: string;
  npi: string;
  existingPhysicianId: number;
};

export default function NPIDuplicateDialog({
  open,
  onClose,
  physicianName,
  npi,
  existingPhysicianId
}: NPIDuplicateDialogProps) {
  const navigate = useNavigate();

  return (
    <Dialog
      title="Duplicate Physician"
      open={open}
      onClose={(_event, _reason) => onClose()}
      minWidth={450}
    >
      <Stack spacing={3} sx={{ py: 2 }}>
        <Typography>
          Dr. {physicianName} (NPI: {npi}) already exists in your practice.
        </Typography>
        <Stack direction="row" spacing={2} justifyContent="flex-end">
          <Button variant="outlined" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              onClose();
              navigate(`/settings/physicians/${existingPhysicianId}/edit`);
            }}
          >
            View Existing
          </Button>
        </Stack>
      </Stack>
    </Dialog>
  );
}